import React from "react";
import { useGame, usePlayer } from "@empirica/core/player/classic/react";
import { completionLinks as defaultCompletionLinks } from "../../../shared/completionLinks.js";

function FeedbackBox() {
  const player = usePlayer();
  const reportForm = player.get("reportForm") || {};
  const [feedback, setFeedback] = React.useState(reportForm.generalFeedback || "");

  function handleFeedbackChange(event) {
    const nextFeedback = event.target.value;
    const currentReportForm = player.get("reportForm") || {};
    setFeedback(nextFeedback);
    player.set("reportForm", {
      ...currentReportForm,
      generalFeedback: nextFeedback,
    });
  }

  return (
    <div className="rounded-md border border-gray-200 bg-white p-5 text-left shadow-sm">
      <label className="block text-xl font-medium text-gray-800">
        Is there anything else you would like to tell us about your experience in this study?
      </label>
      <textarea
        className="mt-3 block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 shadow-sm focus:border-empirica-500 focus:outline-none focus:ring-2 focus:ring-empirica-500"
        rows={5}
        value={feedback}
        onChange={handleFeedbackChange}
      />
    </div>
  );
}

export function CompletionLink({
  unpaid = false,
  partial = false,
  embedded = false,
  showFeedback = true,
}) {
  const game = useGame();
  const completionLinks = game?.get("design")?.completionLinks || defaultCompletionLinks;
  const url = partial
    ? completionLinks.partial
    : unpaid
    ? completionLinks.unpaid
    : completionLinks.paid;

  const content = (
    <div className={`rounded-md border border-empirica-200 bg-empirica-50 p-6 text-gray-900 shadow-sm ${embedded ? "space-y-3" : "w-full max-w-xl space-y-5 text-center"}`}>
      <p className="text-2xl font-semibold">Thank you for your participation.</p>
      <p className="text-xl">
        Click this button to complete the study on CloudResearch.
      </p>
      {url ? (
        <>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-empirica-600 hover:bg-empirica-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-empirica-500"
          >
            Complete study
          </a>
        </>
      ) : (
        <p className="text-xl text-red-700">
          Completion link is not configured for this treatment.
        </p>
      )}
    </div>
  );

  if (embedded) {
    return (
      <>
        {showFeedback ? <FeedbackBox /> : null}
        {content}
      </>
    );
  }

  return (
    <div className="flex min-h-screen w-full items-start justify-center px-6 py-10">
      <div className="w-full max-w-xl space-y-5">
        {showFeedback ? <FeedbackBox /> : null}
        {content}
      </div>
    </div>
  );
}
